import { Component } from '@angular/core';
import { PLATFORM_ENVIRONMENT } from '../../platform-environment';

@Component({
  selector: 'yat-environment-label',
  templateUrl: './environment-label.component.html',
  styleUrls: ['./environment-label.component.scss']
})
export class EnvironmentLabelComponent {
  readonly environmentFrontend = PLATFORM_ENVIRONMENT.name;
  showLabel: boolean = !PLATFORM_ENVIRONMENT.isProduction;

  close(): void {
    this.showLabel = false;
  }
}
